var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { produce } from 'immer';
import { ODGNBFactory } from './ODGNBFactory';
function createODGNBReducer() {
    return function (state
    // action: ODGNBReducerAction
    ) {
        return produce(state, function (_) {
            // TODO with action
            return;
        });
    };
}
function createInitialReducerState(_a) {
    var def = _a.def;
    return { def: def };
}
export var ODGNBContext = React.createContext({});
export var ODGNBProvider = function (reactProps) {
    var children = reactProps.children, props = __rest(reactProps, ["children"]);
    var state = React.useReducer(createODGNBReducer(), createInitialReducerState(props))[0];
    var factory = React.useState(function () { return new ODGNBFactory(props.def); })[0];
    var context = {
        state: state,
        factory: factory,
    };
    return React.createElement(ODGNBContext.Provider, { value: context }, children);
};
export function useGNBContext() {
    return React.useContext(ODGNBContext);
}
//# sourceMappingURL=ODGNBProvider.js.map